/* webpack-strip-block:removed */

export default {
  data() {
    return {
      user: window.user,
      episode_button_share_list: [
        {
          key: 'facebook',
          label: 'Facebook',
          icon: 'la la-external-link-square',
          callback: this.shareOnFacebook,
        },
        {
          key: 'twitter',
          label: 'Twitter',
          icon: 'la la-external-link-square',
          callback: this.shareOnTwitter,
        },
        {
          key: 'whatsapp',
          label: 'WhatsApp',
          icon: 'la la-external-link-square',
          callback: this.shareOnWhatsapp,
        },
        {
          key: 'embed',
          label: 'Embed',
          icon: 'la la-external-link-square',
          callback: this.fireEpisodePreview,
        },
        {
          key: 'player_link',
          label: 'Player Link',
          icon: 'la la-link',
          callback: this.copyPlayerLinkToClipboard,
        },
      ],
      podcast_button_links: [
        {
          key: 'facebook',
          label: 'Facebook',
          icon: 'la la-external-link-square',
          callback: this.shareOnFacebook,
        },
        {
          key: 'twitter',
          label: 'Twitter',
          icon: 'la la-external-link-square',
          callback: this.shareOnTwitter,
        },
        {
          key: 'whatsapp',
          label: 'WhatsApp',
          icon: 'la la-external-link-square',
          callback: this.shareOnWhatsapp,
        },
        {
          key: 'embed',
          label: 'Embed',
          icon: 'la la-external-link-square',
          callback: this.firePodcastPreview,
        },
        {
          key: 'player_link',
          label: 'Player Link',
          icon: 'la la-link',
          callback: this.copyPlayerLinkToClipboard,
        },
        {
          key: 'website_link',
          label: 'Website Link',
          icon: 'la la-link',
          callback: this.copyPodcastWebsiteLinkToClipboard,
        },
        {
          key: 'rss_link',
          label: 'RSS Link',
          icon: 'la la-link',
          callback: this.copyRSSToClipboard,
        },
      ],
    };
  },
  methods: {
    getPodcastShareLinks(exclude_keys = []) {
      let links = _.filter(this.podcast_button_links, link => !exclude_keys.includes(link.key));
      if (!this.user.is_super_admin) {
        links = _.filter(links, link => link.key !== 'website_link');
      }

      return links;
    },
    getEpisodeShareLinks(exclude_keys = []) {
      return _.filter(this.episode_button_share_list, link => !exclude_keys.includes(link.key));
    },
    getDefaultEmbedCode(entity) {
      const player_data = (entity ?? this.entity).player_data;
      const player_url = player_data.default_url;
      const layout = player_data.params.length ? player_data.params.layout : 'legacy';
      const large_iframe = layout === 'square' || player_data.type === 'feed';
      const iframe_height = large_iframe ? 700 : 150;

      return `<iframe seamless src=${player_url} width="100%" height="${iframe_height}" frameborder="0" allow="clipboard-read; clipboard-write" refererpolicy="origin" referrerpolicy="origin"></iframe>`;
    },
    copyEmbedToClipboard(entity) {
      const embed_code = this.getDefaultEmbedCode(entity);
      this.copyValueToClipboard(embed_code, `Copied Embed Link to Clipboard.`);
    },
    copyDirectFileLinkClipboard(entity) {
      const storage_file_url = (entity ?? this.entity).storage_file_url;

      if (!storage_file_url) {
        toastr.error("Item is orphaned");
        return;
      }

      if (!entity.published) {
        toastr.error("Item is unpublished.");
        return;
      }
      this.copyValueToClipboard(storage_file_url, `Copied Direct File Link to Clipboard`);
    },
    copyPlayerLinkToClipboard(entity) {
      this.copyValueToClipboard((entity ?? this.entity).player_data.default_url, `Copied Player Link to Clipboard.`);
    },
    copyRSSToClipboard(entity) {
      this.copyValueToClipboard((entity ?? this.entity).feed_xml_file_url, `Copied RSS link to Clipboard.`);
    },
    copyPodcastWebsiteLinkToClipboard(entity) {
      if (!entity.podcast_website?.enabled && !entity.podcast_website?.id) {
        toastr.error('You have not enabled the Podcast Website');
        return;
      }
      if (entity.podcast_website?.url) {
        this.copyValueToClipboard(entity.podcast_website?.url, 'Copied Podcast Website Link to Clipboard');
      }
    },
    /** @param { Shareable } entity */
    shareOnFacebook(entity) {
      window.FB.ui({
        method: 'share',
        href: `${entity.player_data.default_url}`,
      });
    },
    /**
     * @param { Shareable } entity
     */
    shareOnTwitter(entity) {
      const url = `https://twitter.com/intent/tweet?text=${entity.name}%20${entity.player_data.default_url}`;
      this.popupWindow(url);
    },
    /**
     * @param { Shareable } entity
     */
    shareOnWhatsapp(entity) {
      const url = `https://api.whatsapp.com/send?phone=&text=${entity.name}%20${entity.player_data.default_url}`;
      this.popupWindow(url);
    },
    /**
     * Opens a new window (or tab; browser config dependant)
     * @param { string } url The url of the new window
     */
    popupWindow(url) {
      const w = 626;
      const h = 436;
      const title = 'sharer';

      // Fixes dual-screen position most browsers
      const dual_screen_left = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dual_screen_top = window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const system_zoom = width / window.screen.availWidth;
      const left = (width - w) / 2 / system_zoom + dual_screen_left;
      const top = (height - h) / 2 / system_zoom + dual_screen_top;
      const new_window = window.open(url, title, 'scrollbars=yes, width=' + w / system_zoom + ', height=' + h / system_zoom + ', top=' + top + ', left=' + left);

      // Puts focus on the new_window
      if (window.focus) new_window.focus();
    },

    firePodcastPreview() {
      this.fireModal(`preview-podcast`);
    },

    fireEpisodePreview(episode) {
      this.fireModal(`preview-episode-share-btn-${episode.uuid}`);
    },
  },
};
